import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import { encryptTransform } from "redux-persist-transform-encrypt";
import storage from "redux-persist/lib/storage"; // localStorage
import rootReducer from "./rootReducer";

const encryptor = encryptTransform({
  secretKey: process.env?.REACT_APP_REDUX || "VERY_SUPER_SECRETS_ONEHCM",
  onError: function (error) {
    // Handle error
    console.error("Error Encrypt Redux: ", error)
  },
});

const persisConfig = {
  key: "root",
  storage,
  transforms: [encryptor],
  whitelist: ["dashboardLayout"], // Daftar persist
};

const persistedReducer = persistReducer(persisConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // untuk redux-persist
    }),
});

export const persistor = persistStore(store);
